module.exports = __webpack_public_path__ + "static/img/duijiejigou.963813f.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/7mouth/duijiejigou.png
// module id = BrbJ
// module chunks = 1